import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import ptKnowledgeIngestion from './locales/pt/knowledge-ingestion.json';
import enKnowledgeIngestion from './locales/en/knowledge-ingestion.json';
import ptSidebar from './locales/pt/sidebar.json';
import enSidebar from './locales/en/sidebar.json';
import ptDashboard from './locales/pt/dashboard.json';
import enDashboard from './locales/en/dashboard.json';
import ptSignin from './locales/pt/signin.json';
import enSignin from './locales/en/signin.json';
import ptUsers from './locales/pt/users.json';
import enUsers from './locales/en/users.json';
import ptDreams from './locales/pt/dreams.json';
import enDreams from './locales/en/dreams.json';
import ptTeam from './locales/pt/team.json';
import enTeam from './locales/en/team.json';
import ptTickets from './locales/pt/tickets.json';
import enTickets from './locales/en/tickets.json';
import ptGamification from './locales/pt/gamification.json';
import enGamification from './locales/en/gamification.json';
import ptFeatureFlags from './locales/pt/feature-flags.json';
import enFeatureFlags from './locales/en/feature-flags.json';
import ptSubscription from './locales/pt/subscription.json';
import enSubscription from './locales/en/subscription.json';
import ptCoupons from './locales/pt/coupons.json';
import enCoupons from './locales/en/coupons.json';
import ptAffiliates from './locales/pt/affiliates.json';
import enAffiliates from './locales/en/affiliates.json';
import ptEventsAnalytics from './locales/pt/events-analytics.json';
import enEventsAnalytics from './locales/en/events-analytics.json';
import ptAdmin from './locales/pt/admin.json';
import enAdmin from './locales/en/admin.json';
import ptAuth from './locales/pt/auth.json';
import enAuth from './locales/en/auth.json';
import ptAnalytics from './locales/pt/analytics.json';
import enAnalytics from './locales/en/analytics.json';
import ptChat from './locales/pt/chat.json';
import enChat from './locales/en/chat.json';
import ptNotification from './locales/pt/notification.json';
import enNotification from './locales/en/notification.json';
import ptCuradoria from './locales/pt/curadoria.json';
import enCuradoria from './locales/en/curadoria.json';
import ptCommon from './locales/pt/common.json';
import enCommon from './locales/en/common.json';
import ptAiFeedback from './locales/pt/ai-feedback.json';
import enAiFeedback from './locales/en/ai-feedback.json';

export const resources = {
  en: {
    sidebar: enSidebar,
    knowledgeIngestion: enKnowledgeIngestion,
    dashboard: enDashboard,
    signin: enSignin,
    users: enUsers,
    dreams: enDreams,
    team: enTeam,
    tickets: enTickets,
    gamification: enGamification,
    "feature-flags": enFeatureFlags,
    subscription: enSubscription,
    coupons: enCoupons,
    affiliates: enAffiliates,
    "events-analytics": enEventsAnalytics,
    admin: enAdmin,
    auth: enAuth,
    analytics: enAnalytics,
    chat: enChat,
    notification: enNotification,
    curadoria: enCuradoria,
    common: enCommon,
    "ai-feedback": enAiFeedback,
  },
  pt: {
    sidebar: ptSidebar,
    knowledgeIngestion: ptKnowledgeIngestion,
    dashboard: ptDashboard,
    signin: ptSignin,
    users: ptUsers,
    dreams: ptDreams,
    team: ptTeam,
    tickets: ptTickets,
    gamification: ptGamification,
    "feature-flags": ptFeatureFlags,
    subscription: ptSubscription,
    coupons: ptCoupons,
    affiliates: ptAffiliates,
    "events-analytics": ptEventsAnalytics,
    admin: ptAdmin,
    auth: ptAuth,
    analytics: ptAnalytics,
    chat: ptChat,
    notification: ptNotification,
    curadoria: ptCuradoria,
    common: ptCommon,
    "ai-feedback": ptAiFeedback,
  }
};

// Detect language: localStorage → navigator → fallback 'pt'
const detectedLng =
  localStorage.getItem('i18nextLng') ??
  (navigator.language?.startsWith('en') ? 'en' : 'pt');

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: detectedLng,
    fallbackLng: 'pt',
    supportedLngs: ['pt', 'en'],
    defaultNS: 'sidebar',


    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
